import React, { createContext, useContext, useState, useEffect } from 'react';
import { mockWallets, mockUser } from '../mockDataPalmPay';
import { getDashboard } from '../api/palm';
import { useAuthContext } from './AuthContext';

const WalletContext = createContext();

export const useWallet = () => {
  const context = useContext(WalletContext);
  if (!context) {
    throw new Error('useWallet must be used within a WalletProvider');
  }
  return context;
};

export const WalletProvider = ({ children }) => {
  const [selectedWallet, setSelectedWallet] = useState({}); // Default to UPI wallet
  const [wallets, setWallets] = useState([]);
  const { user } = useAuthContext();

  useEffect(() => {
    const fetchDashboard = async () => {
      if (!user?.id) return;
      const dashboard = await getDashboard(user?.id);
      const wallets = mockWallets.map(wallet => {
        if (wallet.id === "emoney-wallet") {
          return {
            ...wallet,
            balance: dashboard?.user?.balance || 0
          };
        }
        return wallet;
      });
      setWallets(wallets);
      setSelectedWallet(wallets.find(w => w.id === "emoney-wallet"));
    };
    fetchDashboard();
  }, [user?.id]);

  const switchWallet = (walletId) => {
    const wallet = wallets.find(w => w.id === walletId);
    if (wallet) {
      setSelectedWallet(wallet);
    }
  };

  const getTotalBalance = async () => {
    let balance = 0;
    if (!user?.id) return;
    const dashboard = await getDashboard(user?.id);
    wallets.forEach(wallet => {
      if (wallet.id !== "emoney-wallet") {
        balance += wallet.balance;
      } else {
        balance += dashboard?.user?.balance || 0;
      }
    });
    return balance;
  };

  const value = {
    selectedWallet,
    wallets,
    switchWallet,
    getTotalBalance,
  };

  return (
    <WalletContext.Provider value={value}>
      {children}
    </WalletContext.Provider>
  );
};
